import React, { ReactNode } from 'react';

import InvoicesGrid from '../components/InvoiceGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import { IInvoice } from 'src/types/invoice';
import { IProvider } from '../../../../../../../../../types/provider';
import { IStudent } from '../../../../../../../../../types/student';
import Loader from '../../../../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<IInvoice>;
    inProgress: boolean;
    students: Paginated<IStudent>;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
}

export interface OwnProps {
    provider: Partial<IProvider> | null;
    tab: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class InvoicesList extends React.Component<Props> {
    componentDidMount() {
        this.props.getStudents({
            page: 1,
            itemsPerPage: 1200,
        });
    }

    public render(): ReactNode {
        const { data, getData, inProgress, provider, students } = this.props;

        return (
            <div style={{ padding: '30px 0' }}>
                {inProgress ? <Loader /> : null}
                <InvoicesGrid students={students} provider={`${provider?.id}`} data={data} getData={getData} />
            </div>
        );
    }
}

export default InvoicesList;
